import { gql } from '@apollo/client';

export const COMPANY_INTEGRATIONS_QUERY = gql`
    query companyIntegrations {
        companyIntegrations {
            edges {
                node {
                    id
                    integrationTypeId
                    rosterMappingField
                    integrationType { 
                        id
                        name
                        description
                        key
                        fieldSchema
                    }
                }
            }
        }
    }
`;
